module.exports = __webpack_public_path__ + "static/media/Main_Image.79941f09.jpg";